@if (toasts$|async; as toasts) {
  <div class="fixed top-5 right-5 z-[200] max-w-xs">
    @for (toast of toasts; track toast.title) {
      <div
        class="rounded-md bg-slate-800 text-white px-5 py-3.5"
    [ngClass]="{
      'bg-red-500': toast.type === 'error',
      'bg-green-500': toast.type === 'success',
      'bg-yellow-500': toast.type === 'warning'
    }"
        >
        @if (toast.title) {
          <h3 class="font-bold text-xl mb-1.5">
            {{toast.title}}
          </h3>
        }
        {{toast.message}}
      </div>
    }
  </div>
}
